import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Card, { CardActions, CardContent, CardMedia } from 'material-ui/Card';
import Button from 'material-ui/Button';
import Grid from 'material-ui/Grid';

// Components
import PrevNextButtons from './components/PrevNextButtons';
import Images from './components/Images';
import Username from './components/Username';
import Oar from './components/Oar';
import Age from './components/Age';
import DatingRange from './components/DatingRange';
import City from './components/City';
import Priority from './components/Priority';
import Description from './components/Description';
import Profiles from './components/Profiles';
import Message from './components/Message';
import Ommit from './components/Ommit';
import Education from './components/Education';
import Marital from './components/Marital';
import Drinking from './components/Drinking';
import Children from './components/Children';
import Smoking from './components/Smoking';
import Pets from './components/Pets';
import Ethnicity from './components/Ethnicity';
import Faith from './components/Faith';
import Occupation from './components/Occupation';
import Languages from './components/Languages';
import Salary from './components/Salary';
import Summary from './components/Summary';
import Messages from './components/Messages';

class User extends Component {

  render(){
    const { classes, theme, location, data } = this.props;

    return(
      <div>
        <Card className={classes.root}>
          <PrevNextButtons data={data} />
          <Images data={data}/>
          <Description data={data}/>
          <Grid item xs={12}>
            <Grid container className={classes.demo} justify="center" spacing={12}>
              <Grid>
                <Age data={data}/>
              </Grid>
              <Grid>
                <DatingRange data={data}/>
              </Grid>
              <Grid>
                <Oar data={data}/>
              </Grid>
            </Grid>
          </Grid>
          <div className={classes.space1}></div>
          <Priority data={data}/>
          <div className={classes.actions}>
            <Profiles data={data}/>
            <Message data={data}/>
            <Ommit data={data}/>
          </div>
          <div>
            <City data={data}/>
            <Education data={data}/>
            <Marital data={data}/>
            <Drinking data={data}/>
            <Smoking data={data}/>
            <Ethnicity data={data}/>
            <Faith data={data}/>
            <Pets data={data}/>
            <Children data={data}/>
            <Occupation data={data}/>
            <Salary data={data}/>
            <Languages data={data}/>
            <br/>
            <Summary data={data}/>
            <Messages data={data}/>
          </div>
          <div className={classes.bottom}></div>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        search_by_name:state.search_by_name,
        project_id: state.prefix.project_id,
        rrd_data: state.rrd_data,
    };
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    changeRoute: (url) => dispatch(push(url)),
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(User)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Home/scenes/MultifolderView/components/User/index.js